import { InfoIcon } from "@chakra-ui/icons";
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from "@chakra-ui/react";

export const DescriptionPopover = (props: { description: string }) => {
  const { description } = props;
  return (
    <Popover placement="right" trigger="hover" isLazy>
      <PopoverTrigger>
        <InfoIcon color="gray.500" ml="1.5" />
      </PopoverTrigger>
      <PopoverContent
        width="fit-content"
        maxW={{ base: "32", md: "xs", lg: "xl" }}
      >
        <PopoverArrow />
        <PopoverBody
          bg="gray.600"
          fontSize="xs"
          textColor="gray.100"
          fontWeight="medium"
        >
          {description}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
